import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelText as _vModelText, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "cover-auth" }
const _hoisted_2 = { class: "widget-auth" }
const _hoisted_3 = { class: "font-semibold my-0 text-center" }
const _hoisted_4 = { class: "custom-upload-st2" }
const _hoisted_5 = {
  key: 0,
  src: "/public/icons/icon-photo.svg",
  width: "45%",
  class: "icon-white"
}
const _hoisted_6 = { class: "s10" }
const _hoisted_7 = { class: "custom-upload-text-sm" }
const _hoisted_8 = { class: "form-field-split active rounded-20 mt-5 my-6" }
const _hoisted_9 = { class: "form-field-floating full lg w-40" }
const _hoisted_10 = { class: "form-field-floating lg reactive w-60" }
const _hoisted_11 = { class: "custom-upload-st2" }
const _hoisted_12 = {
  key: 0,
  src: "/public/icons/icon-idcard-recto.svg",
  width: "45%",
  class: "icon-white"
}
const _hoisted_13 = { class: "s10" }
const _hoisted_14 = { class: "custom-upload-text-sm" }
const _hoisted_15 = { class: "custom-upload-st2" }
const _hoisted_16 = {
  key: 0,
  src: "/public/icons/icon-idcard-verso.svg",
  width: "45%",
  class: "icon-white"
}
const _hoisted_17 = { class: "s10" }
const _hoisted_18 = { class: "custom-upload-text-sm" }
const _hoisted_19 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.userName), 1),
      _cache[24] || (_cache[24] = _createElementVNode("h2", { class: "font-normal text-center mt-3 mb-7" }, "Identifiez-vous", -1)),
      _createElementVNode("form", {
        class: "form",
        onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
      }, [
        _createElementVNode("label", {
          for: "file-upload-photo",
          class: _normalizeClass(["custom-upload", { active: _ctx.formData.photoProfil }])
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("input", {
              id: "file-upload-photo",
              name: "file-upload-photo",
              type: "file",
              accept: "image/*",
              onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handlePhotoUpload && _ctx.handlePhotoUpload(...args)))
            }, null, 32),
            _createElementVNode("div", {
              class: "s5 custom-upload-img",
              style: _normalizeStyle(_ctx.photoPreviewStyle)
            }, [
              (!_ctx.photoPreview)
                ? (_openBlock(), _createElementBlock("img", _hoisted_5))
                : _createCommentVNode("", true)
            ], 4),
            _createElementVNode("div", _hoisted_6, [
              _cache[6] || (_cache[6] = _createElementVNode("span", { class: "custom-upload-text" }, "Photo de profil", -1)),
              _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.formData.photoProfil ? _ctx.formData.photoProfil.name : 'Charger la photo'), 1)
            ]),
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "s5 right" }, [
              _createElementVNode("img", {
                src: "/public/icons/icon-upload.svg",
                class: "custom-upload-icon"
              })
            ], -1))
          ])
        ], 2),
        _cache[22] || (_cache[22] = _createElementVNode("div", { class: "h-10" }, null, -1)),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _withDirectives(_createElementVNode("select", {
              class: "form-input-select",
              name: "piece_identite_type",
              id: "piece_identite_type",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.pieceIdentiteType) = $event))
            }, [...(_cache[9] || (_cache[9] = [
              _createStaticVNode("<option value=\"\" selected data-v-0f7a754c>Type de pièce</option><option value=\"cni\" data-v-0f7a754c>CNI</option><option value=\"passport\" data-v-0f7a754c>Passeport</option><option value=\"permis\" data-v-0f7a754c>Permis de conduire</option><option value=\"carte_sejour\" data-v-0f7a754c>Carte de séjour</option>", 5)
            ]))], 512), [
              [_vModelSelect, _ctx.formData.pieceIdentiteType]
            ]),
            _cache[10] || (_cache[10] = _createElementVNode("label", { for: "piece_identite_type" }, [
              _createTextVNode("Pièce d'identité "),
              _createElementVNode("b", { class: "color-danger" }, "*")
            ], -1))
          ]),
          _cache[12] || (_cache[12] = _createElementVNode("hr", { class: "hr" }, null, -1)),
          _createElementVNode("div", _hoisted_10, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-input",
              name: "numero_piece",
              id: "numero_piece",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.numeroPiece) = $event)),
              placeholder: ""
            }, null, 512), [
              [_vModelText, _ctx.formData.numeroPiece]
            ]),
            _cache[11] || (_cache[11] = _createElementVNode("label", { for: "numero_piece" }, [
              _createTextVNode("N° de pièce d'identité "),
              _createElementVNode("b", { class: "color-danger" }, "*")
            ], -1))
          ])
        ]),
        _createElementVNode("label", {
          for: "file-upload-recto",
          class: _normalizeClass(["custom-upload my-5", { active: _ctx.formData.pieceRecto }])
        }, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("input", {
              id: "file-upload-recto",
              name: "file-upload-recto",
              type: "file",
              accept: "image/*,.pdf",
              onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleRectoUpload && _ctx.handleRectoUpload(...args)))
            }, null, 32),
            _createElementVNode("div", {
              class: "s5 custom-upload-img",
              style: _normalizeStyle(_ctx.rectoPreviewStyle)
            }, [
              (!_ctx.rectoPreview)
                ? (_openBlock(), _createElementBlock("img", _hoisted_12))
                : _createCommentVNode("", true)
            ], 4),
            _createElementVNode("div", _hoisted_13, [
              _cache[13] || (_cache[13] = _createElementVNode("span", { class: "custom-upload-text uppercase" }, "Pièce recto", -1)),
              _cache[14] || (_cache[14] = _createElementVNode("b", { class: "color-danger" }, "*", -1)),
              _cache[15] || (_cache[15] = _createElementVNode("br", null, null, -1)),
              _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.formData.pieceRecto ? _ctx.formData.pieceRecto.name : 'Charger l\'image'), 1)
            ]),
            _cache[16] || (_cache[16] = _createElementVNode("div", { class: "s5 right" }, [
              _createElementVNode("img", {
                src: "/public/icons/icon-upload.svg",
                class: "custom-upload-icon"
              })
            ], -1))
          ])
        ], 2),
        _createElementVNode("label", {
          for: "file-upload-verso",
          class: _normalizeClass(["custom-upload", { active: _ctx.formData.pieceVerso }])
        }, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("input", {
              id: "file-upload-verso",
              name: "file-upload-verso",
              type: "file",
              accept: "image/*,.pdf",
              onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleVersoUpload && _ctx.handleVersoUpload(...args)))
            }, null, 32),
            _createElementVNode("div", {
              class: "s5 custom-upload-img",
              style: _normalizeStyle(_ctx.versoPreviewStyle)
            }, [
              (!_ctx.versoPreview)
                ? (_openBlock(), _createElementBlock("img", _hoisted_16))
                : _createCommentVNode("", true)
            ], 4),
            _createElementVNode("div", _hoisted_17, [
              _cache[17] || (_cache[17] = _createElementVNode("span", { class: "custom-upload-text uppercase" }, "Pièce verso", -1)),
              _cache[18] || (_cache[18] = _createElementVNode("b", { class: "color-danger" }, "*", -1)),
              _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1)),
              _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.formData.pieceVerso ? _ctx.formData.pieceVerso.name : 'Charger l\'image'), 1)
            ]),
            _cache[20] || (_cache[20] = _createElementVNode("div", { class: "s5 right" }, [
              _createElementVNode("img", {
                src: "/public/icons/icon-upload.svg",
                class: "custom-upload-icon"
              })
            ], -1))
          ])
        ], 2),
        _cache[23] || (_cache[23] = _createElementVNode("p", { class: "text-read text-grey-600 text-center mt-6" }, " Format de fichier supporté: PDF, JPG, PNG, GIF. Taille max: 5MB. ", -1)),
        _createElementVNode("button", {
          type: "submit",
          class: "btn lg w-100 flex-center mt-5",
          disabled: _ctx.isSubmitting
        }, [
          _cache[21] || (_cache[21] = _createElementVNode("img", {
            src: "/public/icons/icon-valider.svg",
            class: "btn-icon",
            alt: ""
          }, null, -1)),
          _createElementVNode("span", null, _toDisplayString(_ctx.isSubmitting ? 'Préparation en cours...' : 'Valider'), 1)
        ], 8, _hoisted_19)
      ], 32)
    ])
  ]))
}